
export class MainMenu {
    build = () => {
        $('#main-menu .site-navigation').on('click', () => {
            if ($('#main-menu .site-navigation').attr('aria-expanded') === 'true') {
                $('#main-menu .js-site-nav-close').show();
                $('#main-menu .js-site-nav-open').hide();
            } else {
                $('#main-menu .js-site-nav-close').hide();
                $('#main-menu .js-site-nav-open').show();
            }
        });
    }
}